module.exports = __webpack_public_path__ + "img/certificate-1.0ee7cfcc.png";